export const phoneNumberInputInstructionsTemplate = <div>
    <p>Enter the mobile number without <br />country code (choose from the dropdown) <br />and zero prefix e.g. 3001234567</p>
</div>